import type { ReactNode } from 'react'
import { NODE_DIMENSIONS } from '@genieartinc/schemas'
import { NodeContainer } from '@/components/canvas/nodes/base/NodeContainer'
import { CardContent } from '@/components/ui/card'
import { withNodeOptimization } from '@/components/canvas/nodes/hoc/withNodeOptimization'

interface Props {
  id: string; title: string; selected?: boolean; children: ReactNode
  state: Record<string, unknown>
  onStateChange: (update: Record<string, unknown> | ((previous: Record<string, unknown>) => Record<string, unknown>)) => void
  /** Defaults to the image-first body shared with ImageFile. */
  contentClassName?: string
}
function FrameConnectionComponent({ id, title, selected, children, state, onStateChange, contentClassName }: Props) {
  return <NodeContainer nodeId={id} title={title} icon="frame" nodeType="frame" width={NODE_DIMENSIONS.FrameInput.width} selected={selected} state={state} onStateChange={onStateChange}>
    <CardContent aria-label={title} role="region" className={contentClassName ?? 'flex flex-1 flex-col items-stretch justify-center overflow-hidden p-1'}>{children}</CardContent>
  </NodeContainer>
}
export const FrameConnection = withNodeOptimization(FrameConnectionComponent, { compareProps: ['id', 'title', 'selected', 'children', 'state', 'onStateChange'] })
